// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"841":"9ddce983","852":"c5f11742"}[chunkId] + ".chunk.css";
};